// Generated by `pnpm tokens` from design/chroma/. Do not edit.

export const themes = ['dark', 'light'] as const
export type Theme = (typeof themes)[number]
export const defaultTheme: Theme = 'dark'

export const palettes = ['iris', 'indigo', 'violet'] as const
export type Palette = (typeof palettes)[number]
export const defaultPalette: Palette = 'iris'

export const textSizes = ['sm', 'md', 'lg'] as const
export type TextSize = (typeof textSizes)[number]
export const defaultTextSize: TextSize = 'md'

export const corners = ['square', 'rounded'] as const
export type Corners = (typeof corners)[number]
export const defaultCorners: Corners = 'square'

export const contrasts = ['standard', 'more'] as const
export type Contrast = (typeof contrasts)[number]
export const defaultContrast: Contrast = 'standard'
